import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { GetMessages } from '../../types/Types';

interface UseGetMessagesProps {
  id: string;
  enabled?: boolean;
  refetchIntervalMs?: number;
}

export function useGetMessages({
  id,
  enabled = true,
  refetchIntervalMs,
}: UseGetMessagesProps) {
  return useQuery({
    enabled,
    refetchInterval: refetchIntervalMs,
    queryKey: ['getMessages', id],
    queryFn: async () => {
      return axiosInstance<GetMessages[]>(getAPIURL(`/Message/userId/${id}/`)).then(
        (response) => response.data,
      );
    },
  });
}